module.exports = __webpack_public_path__ + "static/resources-enable-backup-confirm-618373e814db986a7a112c8493a0657e.png";